"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WATER_BOTTLE_ID = exports.TRIGGER = exports.TRANSLATION = exports.TOOLTIP_ID = exports.THEME = exports.TAG = exports.STAR_ICON = exports.SIZE = exports.POSITION = exports.FLEX_PROPERTIES = exports.CUSTOM_WIDTH = exports.CUSTOM_PADDING = exports.COLOR = void 0;
var TRANSLATION = {
  included: 'Included',
  selectComplimentaryDrink: 'Select your complimentary drink',
  maximizeYourMeal: 'Maximize your meal'
};
exports.TRANSLATION = TRANSLATION;
var FLEX_PROPERTIES = {
  inlineFlex: 'inlineFlex',
  start: 'start'
};
exports.FLEX_PROPERTIES = FLEX_PROPERTIES;
var CUSTOM_PADDING = '4px 12px';
exports.CUSTOM_PADDING = CUSTOM_PADDING;
var TAG = {
  p: 'p',
  div: 'div'
};
exports.TAG = TAG;
var SIZE = {
  medium: 'medium',
  default: 'default',
  normal: 'normal',
  titleNormal: 'titleNormal',
  textSmall: 'textSmall',
  semiSmall: 'semiSmall',
  small: 'small',
  sub: 'sub',
  micro: 'micro'
};
exports.SIZE = SIZE;
var COLOR = {
  green: 'green',
  greenLight: 'greenLight',
  greyDark: 'greyDark',
  greyDarker: 'greyDarker',
  tertiary: 'tertiary',
  neutral: 'neutral'
};
exports.COLOR = COLOR;
var TOOLTIP_ID = 'toolTipId';
exports.TOOLTIP_ID = TOOLTIP_ID;
var CUSTOM_WIDTH = {
  fitContent: 'fit-content'
};
exports.CUSTOM_WIDTH = CUSTOM_WIDTH;
var POSITION = {
  top: 'TOP',
  bottom: 'BOTTOM'
};
exports.POSITION = POSITION;
var TRIGGER = {
  click: 'click'
};
exports.TRIGGER = TRIGGER;
var THEME = {
  airasiaClassic: 'AIRASIA_CLASSIC'
};
exports.THEME = THEME;
var STAR_ICON = {
  size: 'titleNormal',
  color: 'yellow',
  icon: 'StarsRounded'
};
exports.STAR_ICON = STAR_ICON;
var WATER_BOTTLE_ID = 'BWAK';
exports.WATER_BOTTLE_ID = WATER_BOTTLE_ID;